// extracted by mini-css-extract-plugin
module.exports = {"headingCopyMessage":"styles_headingCopyMessage__g9O_A","headingIconWrapper":"styles_headingIconWrapper__ZnHUL"};